/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class GambleParser {

    static parse(cfg, settings, options) {
        if (settings) {
            if (options.isRTG && (!cfg.gamble || !cfg.gamble.type)) {
                const type = 'pie';
                cfg.gamble = {
                    type,
                    enabled: settings.game.hasGambleGame,
                    basePath: `${cfg.game.preconfig.cdn}../../gambles/${type}/`,
                };
            }

            // Temp disable for ios10
            if (options.isRTG && cfg.gamble.enabled === true) {
                cfg.gamble.enabled = !options.isIOS10;
            }
        }

        return cfg.gamble;
    }


}


module.exports = GambleParser;
